// mindzera-frontend/src/mapGuard.js
// Logs whenever `.map` is accessed or called on a non-array.

// ── 1. Guard property access (obj.map) ────────────────────────────────
const origDescriptor = Object.getOwnPropertyDescriptor(Array.prototype, 'map');
Object.defineProperty(Object.prototype, 'map', {
  get() {
    const val = origDescriptor.get.call(this);
    if (!Array.isArray(this)) {
      // eslint-disable-next-line no-console
      console.warn('BAD .map() property access on →', this);
    }
    return val;
  },
  configurable: true
});

// ── 2. Guard direct invocation (obj.map(fn)) ──────────────────────────
(() => {
  const orig = Array.prototype.map;
  Array.prototype.map = function (...args) {
    if (!Array.isArray(this)) {
      // eslint-disable-next-line no-console
      console.warn('BAD .map() CALL →', this);
    }
    return orig.apply(this, args);
  };
})();
